var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdditionalDescriptionEdit',{attrs:{"entity-type":_vm.BUSINESS_TYPE.GROCER,"entity-id":+_vm.$route.params.id,"category-id":+_vm.$route.params.category_id}})}
var staticRenderFns = []

export { render, staticRenderFns }